const headerMenuDevices = {
	data() {
		return {
			showMenu: false,
			activeIds: [],
			activeTexts: [],
			noscrollClassName: 'noscroll-devices'
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.header = jQuery(this.$el)
			this.header.headerScroll()
		})
	},
	methods: {
		toggleMenu: function () {

			this.showMenu ? this.closeMenu() : this.openMenu()

		},

		openMenu(){
			this.showMenu = true
			this.disableBodyScroll()
		},

		closeMenu(){
			this.showMenu = false
			this.activeIds = []
			this.activeTexts = []
			this.enableBodyScroll()
		},

		openSubMenu: function (event) {
			var element = event.target

			this.activeIds.push(element.getAttribute('data-id'))
			this.activeTexts.push(element.getAttribute('data-text'))
		},

		goBack: function () {
			this.activeIds.splice(-1, 1)
			this.activeTexts.splice(-1, 1)
		},

		onClickHeader: function () {
			return false
		},

		disableBodyScroll: function () {
			jQuery('body, html').addClass(this.noscrollClassName)
		},

		enableBodyScroll: function () {
			jQuery('body, html').removeClass(this.noscrollClassName)
		},

		includedInPath: function (value) {
			return this.activeIds.includes(value)
		}
	},

	computed: {
		parentId: function () {
			return this.activeIds[this.activeIds.length - 1]
		},

		parentText: function () {
			return this.activeTexts[this.activeTexts.length - 1]
		},

		showBack: function () {
			return this.activeIds.length
		}
	}
}
const headerMenuDevicesApp = Vue.createApp(headerMenuDevices)
const selHeaderDevices = document.querySelector('#header-devices')
let headerMenuDevicesMounted
if(selHeaderDevices)
	headerMenuDevicesMounted = headerMenuDevicesApp.mount(selHeaderDevices)